export default __webpack_public_path__ + "static/media/icon_tools.ec443e3b.svg";